<template>
	<!--
		bullet_generation_tool has its own paywall (bullet-generator-paywall-modal);
		it hands back here via showModal when the user picks Upgrade Plan.
	-->
	<Modal
		v-if="(showLimitExceed && currentFeature !== 'bullet_generation_tool') || showModal"
		:max-width="'max-w-[690px]'"
		:hide-actions="true"
		:prevent-scrolling="false"
		@modal:close="closeSubscriptionModal"
	>
		<template #body>
			<div>
				<subscription-purchase-options
					v-model="success"
					:allow-exit-to-free-plan="true"
					:exceed-limit="true"
					:error-message-exceeded-limit="currentFeatureExceedMessage"
				/>
			</div>
			<payment-success v-if="success" />
		</template>
	</Modal>
</template>

<script setup>
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { usePremiumNudgeStore } from '../store/nudge-premium.store';
import { useSubscriptionPlanStore } from '../store/subscription.store';
import { useFeatureUsageStore } from '../store/feature-usage.store';
import { useSubscriptionTrackerStore } from '../store/subscription-tracker.store';

import PaymentSuccess from '../components/purchase/subscription/success.vue';
import SubscriptionPurchaseOptions from '../components/subscription-purchase-options.vue';
import Modal from '../components/modal.vue';

const premiumNudgeStore = usePremiumNudgeStore();
const subscriptionPlanStore = useSubscriptionPlanStore();
const featuresUsageExceedStore = useFeatureUsageStore();
const { showModal } = storeToRefs(premiumNudgeStore);
const { currentFeatureExceedMessage, showLimitExceed, currentFeature } = storeToRefs(featuresUsageExceedStore);
const subscriptionTrackerStore = useSubscriptionTrackerStore();

const success = ref(false);

const closeSubscriptionModal = async() => {
	await subscriptionPlanStore.handleCloseModal();
	currentFeature.value = null;
	currentFeatureExceedMessage.value = '';
};

watch(
	() => showModal.value && !showLimitExceed.value,
	(visible) => {
		if (visible) {
			subscriptionTrackerStore.trackModal('post-onboarding');
		}
	}
);
</script>
